/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 17:45
 * Desc: 虚拟店长管理-虚拟店长信息-分销历史
 */

import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import ExportFile from '../exportFile';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';
import { parseSec } from '@/util';
@Component({
  components: {
    ExportFile,
  },
})
export default class DistributeBoardHistory extends Vue {
  /* 数据 */

  /**
   * siteId
   * @type {number}
   */
  @Prop({ default: 0 }) siteId: number;
  @Prop({ default: 0 }) guiderId: number;
  @Prop({
    default() {
      return [];
    },
  })
    dater;

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 分销历史
   * @type {number}
   */
  public distributeHistoryList: Array<DistributeBoardHistory> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 排序名称
   * @type {string}
   */
  public order = '';

  /**
   * 排序方式
   * @type {string}
   */
  public orderBy = '';

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 佣金到账状态
   * @type {string}
   */
  public profitInState = '';

  /**
   * 分销类型
   * @type {number}
   */
  public distributionType: number | string = '';

  /**
   * 角色标签类型
   * @type {number}
   */
  public tagType: number | string = '';

  /**
   * 是否选中列表项
   * @type {boolean}
   */
  public isSelected = false;

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;

  /**
   * 分销类型列表
   */
  public distributionTypeList = PolicyTypeText;

  /**
   * 角色标签列表
   */
  public tagTypeList: ItemArray = [];

  /**
   * 分销类型
   */
  public policyType = '';

  /* 方法 */

  /**
   * 获取角色标签列表
   * @return null
   */
  public getTagList() {
    IPSService.guiderTagList({
      postParams: {
        siteCode: [],
      },
    }).then((response) => {
      this.tagTypeList = response.list;
    });
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchDistributeHistory() {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeHistoryList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getDistributeHistoryList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getDistributeHistoryList();
  }

  public dateChange() {
    this.page = 1;
    this.getDistributeHistoryList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
  }

  ipsGetList(postParams) {
    IPSService.reportProfitList({ postParams }).then((res: ItemObject) => {
      this.totalCount = res.count;
      if (res && res.list && res.list.length > 0) {
        res.list.forEach((item) => {
          item.orderPayTime = Functions.emptyVaribleHandler(item.orderPayTime);
          item.profitFinishTime = Functions.emptyVaribleHandler(item.profitFinishTime);
          item.goodsCode = Functions.emptyVaribleHandler(item.goodsCode);
          item.goodsName = Functions.emptyVaribleHandler(item.goodsName);
          item.orderSn = Functions.emptyVaribleHandler(item.orderSn);
          item.siteCode = Functions.emptyVaribleHandler(item.siteCode);
          item.siteName = Functions.emptyVaribleHandler(item.siteName);
          item.perCent = Functions.emptyVaribleHandler(item.perCent);
          item.sPercent = Functions.emptyVaribleHandler(item.sPercent);
          item.profit = Number(item.profit ? item.profit.toFixed(2) : 0);
          item.sProfit = Number(item.sProfit ? item.sProfit.toFixed(2) : 0);
          item.tagName = Functions.emptyVaribleHandler(item.tagName);
          item.sTagName = Functions.emptyVaribleHandler(item.sTagName);
        });
      }
      this.distributeHistoryList = res.list;
    });
  }

  /**
   * 获取虚拟店长分销历史
   * @return null
   */
  public getDistributeHistoryList(): void {
    this.distributeHistoryList = [];
    const postParams: ItemObject = {
      siteId: Number(this.siteId),
      keywords: this.keywords,
      profitInState: this.profitInState !== '' && this.profitInState !== '3' ? Number.parseInt(this.profitInState) : 9,
      policyType: this.policyType === '' ? 9 : this.policyType,
      distributionType: this.distributionType === '' ? 3 : this.distributionType,
      tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
      // tag: this.tagType === "" ? 9 : Number(this.tagType),
      // distributionType:
      //   this.distributionType === "" ? 3 : (Number(this.distributionType) === 0 || Number(this.distributionType) === 1 ? Number(this.distributionType) : 3),
      page: this.page,
      pageSize: this.pageSize,
    };
    if (this.orderBy) {
      postParams.orderBy = this.orderBy;
      postParams.order = this.order;
    }
    if (this.guiderId) {
      postParams['vGuiderId'] = +this.guiderId;
    }
    if (this.date && this.date.length) {
      const sTime = parseSec(5, this.date[0]) || '';
      const eTime = parseSec(6, this.date[1]) || '';
      postParams['startTime'] = moment(sTime).format('YYYY-MM-DD HH:mm:ss');
      postParams['endTime'] = moment(eTime).format('YYYY-MM-DD HH:mm:ss');
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        postParams['startTime'] = moment(this.date[0]).format('YYYY-MM-DD HH:mm:ss');
        postParams['endTime'] = moment(this.date[1]).format('YYYY-MM-DD HH:mm:ss');
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  /**
   * 列表排序
   * @param {ItemObject} column
   * @return null
   */
  public onSortChange(column: ItemObject): void {
    this.page = 1;
    this.pageSize = 10;
    this.order = column.prop;
    if (column.order) {
      this.orderBy = column.order.split('ending')[0].toUpperCase();
    } else {
      this.orderBy = '';
    }
    this.getDistributeHistoryList();
  }

  /**
   * 选择佣金到账状态
   * @return null
   */
  public onProfitInStateChange(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeHistoryList();
  }

  /**
   * 选择分销类型
   */
  public onPolicyTypeChange(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeHistoryList();
  }

  /**
   * 顾客身份筛选
   */
  public tagTypeChange(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeHistoryList();
  }

  /**
   * 收益等级筛选
   */
  distributionTypeChange(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeHistoryList();
  }

  get exportParams() {
    const postParams = {
      exportType: 'profitIn',
      params: {
        siteId: Number(this.siteId),
        keywords: this.keywords,
        profitInState: this.profitInState !== '' && this.profitInState !== '3' ? Number.parseInt(this.profitInState) : 9,
        policyType: this.policyType === '' ? 9 : this.policyType,
        distributionType: this.distributionType === '' ? 3 : this.distributionType,
        tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
        orderBy: this.orderBy,
        order: this.order,
      },
    };
    if (this.guiderId) {
      postParams.params['vGuiderId'] = +this.guiderId;
    }
    if (this.date && this.date.length) {
      const sTime = parseSec(5, this.date[0]) || '';
      const eTime = parseSec(6, this.date[1]) || '';
      postParams.params['startTime'] = moment(sTime).format('YYYY-MM-DD HH:mm:ss');
      postParams.params['endTime'] = moment(eTime).format('YYYY-MM-DD HH:mm:ss');
    }
    return postParams;
  }

  /**
   * 当组建创建时
   */
  public created() {
    this.defaultStart = parseSec(3);
    this.defaultEnd = parseSec(4);
    if (this.dater && this.dater.length > 0) {
      this.date = [new Date(this.dater[0] * 1000), new Date(this.dater[1] * 1000)];
    }
    this.getDistributeHistoryList(); // 获取虚拟店长分销历史
    this.getTagList();
  }

  /**
   * 身份文本
   */
  public getTag(val): string {
    switch (val) {
      case 0:
        return '普通顾客';
      case 1:
        return '公司员工';
      case 2:
        return '公司导购';
      default:
        return '/';
    }
  }
}
